export const environment = {
  production: false,
  env:'develop',
  // baseUrlAPI: 'http://localhost:5000/dev',
  baseUrlAPI: 'https://rwb35eimx9.execute-api.us-east-1.amazonaws.com/dev',
  baseWssAPI: 'wss://3nhnr2pz07.execute-api.us-east-1.amazonaws.com/development',//'wss://7ck2h620b7.execute-api.us-east-1.amazonaws.com/dev',
  baseUrlStore: 'store.cbntech.xyz',
  baseUrlDomain: 'cbntech.xyz',
  redirectUriDivemotor: 'http://localhost:4200',
  baseIntegrationUrlDomain: 'api-dev.cbntech.xyz',
  opensearchDomain: "companies_dev",//por eliminar
  googleAnalyticsId: 'G-44HSSRNMY1',
  authCofi: "https://qas-btpcore-6ictvy3v.launchpad.cfapps.us10.hana.ondemand.com/60c5fcb9-8b0a-433d-b98a-dfa4f75411e5.comindraloginportal.comindraloginportal-0.0.1/index.html",
  recaptchaSiteKey: '6LcsAkorAAAAAGKl-S77I2pWJxGydnLV2TmZ_syE',
  timeInactivity: 115 ,
  baseUrlAPINEW: 'https://platform-api.cbntech.xyz',
  baseUrlAPIPlatform: 'https://api-platform.cbntech.xyz',
  cbnClientId: "0b942521-5ebc-4a7f-af14-dd8dda58a4aa",
  cbnTenantId: "1448f08d-e6c5-4fc9-8224-0dc425dbe80f",
  trafiguraClientId: "579b7c42-8d48-4782-b9a2-439c014ab075",
  trafiguraTenantId: "98e0fe99-0239-47f6-8a08-2da6a29e6af3"
};
